// import React, { useState, useRef, useEffect } from 'react';
// import { motion } from 'motion/react';
// import { ArrowLeft, Check, Loader2, RefreshCw } from 'lucide-react';

// interface OtpLoginProps {
//   mobile: string;
//   onBack: () => void;
//   onSuccess: () => void;
// }

// type ButtonState = 'default' | 'loading' | 'success' | 'error';

// export function OtpLogin({ mobile, onBack, onSuccess }: OtpLoginProps) {
//   const [otp, setOtp] = useState(['', '', '', '', '', '']);
//   const [error, setError] = useState('');
//   const [buttonState, setButtonState] = useState<ButtonState>('default');
//   const [resendTimer, setResendTimer] = useState(30);
//   const [canResend, setCanResend] = useState(false);
//   const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

//   // Timer countdown
//   useEffect(() => {
//     if (resendTimer > 0) {
//       const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
//       return () => clearTimeout(timer);
//     } else {
//       setCanResend(true);
//     }
//   }, [resendTimer]);

//   const handleChange = (index: number, value: string) => {
//     // Only allow numbers
//     if (value && !/^\d$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;
//     setOtp(newOtp);
//     setError('');

//     // Auto-focus next input
//     if (value && index < 5) {
//       inputRefs.current[index + 1]?.focus();
//     }

//     // Auto-submit when all filled
//     if (newOtp.every(digit => digit !== '') && index === 5) {
//       handleSubmit(newOtp.join(''));
//     }
//   };

//   const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
//     if (e.key === 'Backspace' && !otp[index] && index > 0) {
//       inputRefs.current[index - 1]?.focus();
//     }
//   };

//   const handlePaste = (e: React.ClipboardEvent) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
//     const newOtp = [...otp];

//     pastedData.split('').forEach((digit, index) => {
//       newOtp[index] = digit;
//     });

//     setOtp(newOtp);

//     // Focus last filled input or first empty
//     const lastFilledIndex = pastedData.length - 1;
//     inputRefs.current[Math.min(lastFilledIndex, 5)]?.focus();

//     // Auto-submit if complete
//     if (pastedData.length === 6) {
//       handleSubmit(pastedData);
//     }
//   };

//   const handleSubmit = async (otpValue: string) => {
//     setError('');

//     if (otpValue.length !== 6) {
//       setError('Please enter complete OTP');
//       setButtonState('error');
//       setTimeout(() => setButtonState('default'), 500);
//       return;
//     }

//     // Simulate API call
//     setButtonState('loading');

//     setTimeout(() => {
//       // Mock success (in real app, validate OTP)
//       setButtonState('success');
//       setTimeout(() => {
//         onSuccess();
//       }, 800);
//     }, 1500);
//   };

//   const handleResend = () => {
//     if (!canResend) return;

//     // Reset state
//     setOtp(['', '', '', '', '', '']);
//     setResendTimer(30);
//     setCanResend(false);
//     inputRefs.current[0]?.focus();

//     // Simulate sending OTP
//     console.log('OTP resent to:', mobile);
//   };

//   return (
//     <div className="space-y-6">
//       {/* Back Button */}
//       <button
//         type="button"
//         onClick={onBack}
//         className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
//       >
//         <ArrowLeft className="w-4 h-4" />
//         Change mobile number
//       </button>

//       {/* Mobile Display */}
//       <div className="p-3 bg-muted/50 rounded-xl border border-border">
//         <p className="text-sm text-muted-foreground">OTP sent to</p>
//         <p className="font-medium text-foreground">{mobile}</p>
//       </div>

//       {/* OTP Input */}
//       <div className="space-y-2">
//         <label className="block text-sm font-medium text-foreground">
//           Enter 6-digit OTP
//         </label>
//         <div className="flex gap-2 justify-between">
//           {otp.map((digit, index) => (
//             <input
//               key={index}
//               ref={el => inputRefs.current[index] = el}
//               type="text"
//               inputMode="numeric"
//               maxLength={1}
//               value={digit}
//               onChange={(e) => handleChange(index, e.target.value)}
//               onKeyDown={(e) => handleKeyDown(index, e)}
//               onPaste={index === 0 ? handlePaste : undefined}
//               className={`w-full aspect-square text-center text-2xl font-bold bg-muted/50 border-2 rounded-xl text-foreground focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all ${
//                 error || buttonState === 'error' ? 'border-red-500 shake' : 'border-border'
//               }`}
//             />
//           ))}
//         </div>
//         {error && (
//           <motion.p
//             initial={{ opacity: 0, y: -10 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-sm text-red-500"
//           >
//             {error}
//           </motion.p>
//         )}
//       </div>

//       {/* Resend OTP */}
//       <div className="text-center">
//         {canResend ? (
//           <button
//             type="button"
//             onClick={handleResend}
//             className="text-sm text-primary hover:underline flex items-center justify-center gap-2"
//           >
//             <RefreshCw className="w-4 h-4" />
//             Resend OTP
//           </button>
//         ) : (
//           <p className="text-sm text-muted-foreground">
//             Resend OTP in <span className="font-semibold text-foreground">{resendTimer}s</span>
//           </p>
//         )}
//       </div>

//       {/* Verify Button */}
//       <motion.button
//         type="button"
//         onClick={() => handleSubmit(otp.join(''))}
//         disabled={buttonState === 'loading' || buttonState === 'success'}
//         whileHover={buttonState === 'default' ? { scale: 1.02 } : {}}
//         whileTap={buttonState === 'default' ? { scale: 0.98 } : {}}
//         className={`w-full py-3 rounded-xl font-semibold shadow-lg transition-all duration-300 flex items-center justify-center gap-2 ${
//           buttonState === 'success'
//             ? 'bg-green-500 text-white'
//             : buttonState === 'error'
//             ? 'bg-red-500 text-white shake'
//             : 'bg-gradient-to-r from-primary to-accent text-white hover:shadow-xl hover:shadow-primary/30'
//         }`}
//       >
//         {buttonState === 'loading' && (
//           <>
//             <Loader2 className="w-5 h-5 animate-spin" />
//             Verifying...
//           </>
//         )}
//         {buttonState === 'success' && (
//           <>
//             <motion.div
//               initial={{ scale: 0 }}
//               animate={{ scale: 1 }}
//               transition={{ type: 'spring', stiffness: 500 }}
//             >
//               <Check className="w-5 h-5" />
//             </motion.div>
//             Verified!
//           </>
//         )}
//         {(buttonState === 'default' || buttonState === 'error') && 'Verify OTP'}
//       </motion.button>

//       {/* Help Text */}
//       <p className="text-xs text-center text-muted-foreground">
//         Didn't receive the code? Check your SMS or try resending.
//       </p>
//     </div>
//   );
// }




import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Check, Loader2, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const OtpLogin = ({ mobile, onBack, onSuccess }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [buttonState, setButtonState] = useState('default');
  const [resendTimer, setResendTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [resendTimer]);

  const handleChange = (index, value) => {
    if (value && !/^\d$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setError('');
    if (value && index < 5) inputRefs.current[index + 1]?.focus();
    if (newOtp.every(d => d !== '') && index === 5) handleSubmit(newOtp.join(''));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    const newOtp = [...otp];
    pasted.split('').forEach((digit, idx) => newOtp[idx] = digit);
    setOtp(newOtp);
    inputRefs.current[Math.min(pasted.length, 5)]?.focus();
    if (pasted.length === 6) handleSubmit(pasted);
  };

  const handleSubmit = (otpValue) => {
    setError('');
    if (otpValue.length !== 6) {
      setError('Please enter complete OTP');
      setButtonState('error');
      setTimeout(() => setButtonState('default'), 500);
      return;
    }
    setButtonState('loading');
    setTimeout(() => {
      setButtonState('success');
      setTimeout(onSuccess, 800);
      navigate('/builder');
    }, 1500);
  };

  const handleResend = () => {
    if (!canResend) return;
    setOtp(['', '', '', '', '', '']);
    setResendTimer(30);
    setCanResend(false);
    inputRefs.current[0]?.focus();
    console.log('OTP resent to:', mobile);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Back Button */}
      <button
        onClick={onBack}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 14,
          color: '#6B7280',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        <ArrowLeft style={{ width: 16, height: 16 }} />
        Change mobile number
      </button>

      {/* Mobile Display */}
      <div
        style={{
          padding: 12,
          background: 'rgba(243, 244, 246, 0.5)',
          borderRadius: 16,
          border: '1px solid #D1D5DB',
        }}
      >
        <p style={{ fontSize: 14, color: '#6B7280', margin: 0 }}>OTP sent to</p>
        <p style={{ fontSize: 16, fontWeight: 500, margin: 0 }}>{mobile}</p>
      </div>

      {/* OTP Input */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <label style={{ fontSize: 14, fontWeight: 500 }}>Enter 6-digit OTP</label>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={el => inputRefs.current[index] = el}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={e => handleChange(index, e.target.value)}
              onKeyDown={e => handleKeyDown(index, e)}
              onPaste={index === 0 ? handlePaste : undefined}
              style={{
                flex: 1,
                aspectRatio: '1 / 1',
                width: 40, // explicit width
                height: 40, // explicit height
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 'bold',
                background: 'rgba(243, 244, 246, 0.5)',
                border: `2px solid ${error || buttonState === 'error' ? '#EF4444' : '#D1D5DB'}`,
                borderRadius: 16,
                outline: 'none',
              }}
            />
          ))}
        </div>
        {error && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            style={{ fontSize: 14, color: '#EF4444', margin: 0 }}
          >
            {error}
          </motion.p>
        )}
      </div>

      {/* Resend OTP */}
      <div style={{ textAlign: 'center' }}>
        {canResend ? (
          <button
            onClick={handleResend}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              fontSize: 14,
              color: '#8B5CF6',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <RefreshCw style={{ width: 16, height: 16 }} />
            Resend OTP
          </button>
        ) : (
          <p style={{ fontSize: 14, color: '#6B7280', margin: 0 }}>
            Resend OTP in <span style={{ fontWeight: 500, color: '#111827' }}>{resendTimer}s</span>
          </p>
        )}
      </div>

      {/* Verify Button */}
      <motion.button
        onClick={() => handleSubmit(otp.join(''))}
        disabled={buttonState === 'loading' || buttonState === 'success'}
        whileHover={buttonState === 'default' ? { scale: 1.02 } : {}}
        whileTap={buttonState === 'default' ? { scale: 0.98 } : {}}
        style={{
          width: '100%',
          padding: '12px 0',
          borderRadius: 16,
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          cursor: buttonState === 'loading' || buttonState === 'success' ? 'not-allowed' : 'pointer',
          background:
            buttonState === 'success'
              ? '#22C55E'
              : buttonState === 'error'
                ? '#EF4444'
                : 'linear-gradient(90deg, #8B5CF6 0%, #EC4899 100%)',
          color: '#fff',
        }}
      >
        {buttonState === 'loading' && (
          <>
            <Loader2 style={{ width: 20, height: 20, animation: 'spin 1s linear infinite' }} /> Verifying...
          </>
        )}
        {buttonState === 'success' && (
          <>
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 500 }}>
              <Check style={{ width: 20, height: 20 }} />
            </motion.div>
            Verified!
          </>
        )}
        {(buttonState === 'default' || buttonState === 'error') && 'Verify OTP'}
      </motion.button>

      {/* Help Text */}
      <p style={{ fontSize: 12, color: '#6B7280', textAlign: 'center', margin: 0 }}>
        Didn't receive the code? Check your SMS or try resending.
      </p>
    </div>
  );
};

export default OtpLogin;

